// export const BASE_URL = "http://localhost:4000/api/v1";
// export const BACKEND_URL = "http://localhost:4000";
export const BASE_URL = "https://mdbackend.onrender.com/api/v1";
export const BACKEND_URL = "https://mdbackend.onrender.com";
